import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
// import mock5 from "../img/mock5.png"

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */


/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Bruno",
    lastName: "Kambere",
    initials: "contact", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Software Engineer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: '🪄 ',
            text: 'I\'m a magician 🤗, I turn coffee into code'
        },
        // {
        //     emoji: '🌍',
        //     text: 'based in DRCongo'
        // },
        {
            emoji: "💻",
            text: "Web Developer at EvoluData"
        },
        {
            emoji: "📧",
            text: "brunokambere@gmail.com"
        }
    ],
    socials: [
        {
            link: "https://github.com/kambereBr",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/bruno-kambere",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        },
        {
            link: "https://twitter.com/kambereBr",
            icon: "fa fa-twitter",
            label: 'twitter'
        },
        {
            link: "https://medium.com/@brunokambere",
            icon: "fa fa-medium",
            label: 'medium'
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Full-stack software engineer with 7+ years of experience delivering scalable applications, modernizing open-source platforms, and leading digital transformation initiatives. Proven ability to lead technical teams, contribute to high-impact projects, and train enterprise users on cutting-edge technologies. Passionate about clean code, open-source, and solving real-world problems through tech.",
    skills:
        {
            proficientWith: ['JavaScript', 'React', 'Redux', 'jQuery', 'Bootstrap', 'Tailwind CSS'],
            exposedTo: ['Java', 'PHP', 'Ruby', 'PostgreSQL', 'MySQL', 'MongoDB', 'SQLite'],
            tdd: ['Jest', 'RSpec', 'Capybara', 'PHPUnit', 'PHPSpec', 'JUnit'],
            tools: ['Git', 'GitHub', 'Netlify', 'Postman', 'Chrome Dev Tools', 'Android Studio', 'Firebase', 'AWS'],
            professional: ['Remote Pair-Programming', 'Teamwork', 'Mentoring', 'Agile', 'OOP'],
        }
    ,
    hobbies: [
        {
            label: 'reading',
            emoji: '📖'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'music',
            emoji: '🎧'
        },
        {
            label: 'traveling',
            emoji: '✈️'
        }
// Same as above, change the emojis to match / relate to your hobbies or interests.
// You can also remove the emojis if you'd like, I just think they look cute :P
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        {
            title: "UzaShop",
            description: "UzaShop is a versatile cloud-based point of sale (POS) system designed to streamline business operations.",
            stack: ["JavaScript", "Boostrap", "jQuery", "PHP", "Laravel", "MySQL", "JAVA"],
            live: "https://uzashop.co/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "#", // this should be a link to the **repository** of the project, where the code is hosted.
            privateCode: true, // set this to true if the code is private (i.e. not on github, etc.)
            image: mock1
        },
        {
            title: "ZeroConflit",
            description: "ZeroConflit is a platform that allows to report and map plots conflicts in the DRCongo",
            stack: ["JavaScript", "Boostrap", "jQuery", "PHP", "Laravel", "MySQL", "JAVA"],
            live: "https://zeroconflit.org/localisation",
            source: "#",
            privateCode: true,
            image: mock2
        },
        {
            title: "eVote",
            description: "eVote is an innovative eVoting system, originally designed for academic elections. This platform not only streamlines the voting process but also offers real-time results, providing an efficient and transparent experience for users",
            stack: ["JavaScript", "Boostrap", "jQuery", "PHP", "Laravel", "MySQL", "JAVA"],
            live: "https://evote.uzashop.co/realTimeResult",
            source: "#",
            privateCode: true,
            image: mock3
        },
        {
            title: "eArchive",
            description: "eArchive is an innovative cadastral land management system designed to aid individuals displaced by natural disasters, specifically volcanic eruptions",
            stack: ["JavaScript", "Boostrap", "jQuery", "PHP", "Laravel", "PostgreSQL", "JAVA"],
            live: "https://numerique.nordkivu.gouv.cd",
            source: "#",
            privateCode: true,
            image: mock4
        },
        // {
        //     title: "ReviewMe",
        //     description: "ReviewMe stands as an innovative platform designed to foster a global community of developers, facilitating collaborative code reviews and knowledge sharing",
        //     stack: ["JavaScript", "Boostrap", "Postgresql", "Ruby", "RoR"],
        //     live: "https://kamberebr.github.io/ReviewMe/index.html",
        //     source: "https://github.com/kambereBr/ReviewMe",
        //     privateCode: false,
        //     image: mock5
        // }
    ]
}
